import { put, takeLatest, all, select, call, fork } from 'redux-saga/effects';
import * as selectors from '../containers/selectors';
import apiClient from '../../../utils/apiClient';
import { UPDATE_CART_URL } from '../../../containers/APIurls';
import { BUNDLE } from '../../../containers/bundleConversionUtils';
import { getCartInfo, fetchFiosTv, getFloatingCartDetails, processFloatingCartDetails } from '../../../containers/bundleConversionSaga';
import { PRD_TYPES } from '../../../Pages/CustomizeOrder/containers/constants';
import filter from 'lodash/filter';


function* updateSelectedPhoneService(selectedPhoneService) {

    const constructedPhoneInfo = {
        "serviceName": selectedPhoneService.data.value,
        "price": selectedPhoneService.data.selectedPrice
    };

    yield put({ type: "UPDATE_SELECTED_PHONE_SERVICE_IN_STATE", data: constructedPhoneInfo });
    // yield* UpdateFloatingCart();
}

function* updateNLines(lines) {

    const constructedPhoneLines = lines.data.map((line) => {
        let tmp = {
            "plans": [],
            "PName": "Business Digital Voice",
            "TN": line.NewTN?.replace(/-/g, "")
        };

        return tmp;
    });

    yield put({ type: "UPDATE_N_LINES_IN_STATE", data: constructedPhoneLines });
    // yield* UpdateFloatingCart();
}

function* updateEquipments(equipments) {

    const selectedEquipments = equipments.data
        .phoneList.filter(equipment => equipment.Quantity >= 1)
        .map((equipment) => {
            const eachEquip = {
                "IsBdvEquip": false,
                "offerName": equipment.PrdName + "(" + equipment.Quantity + ")",
                "price": (parseInt(equipment.eachMonthPrice) * parseInt(equipment.Quantity)).toString(),
                "wavied": false
            }
            return eachEquip;
        });

    /*{
        "Fmonth": [
            {
                "IsBdvEquip": false,
                "offerName": "",
                "price": 0,
                "wavied": false
            },
            {
                "IsBdvEquip": false,
                "offerName": "",
                "price": 0,
                "wavied": false
            },
            {
                "IsBdvEquip": false,
                "offerName": "",
                "price": 0,
                "wavied": false
            }
        ],*/

    yield put({ type: "UPDATE_EQUIPMENTS_IN_STATE", data: selectedEquipments });
    yield put({ type: "UPDATE_ONE_TIME_CHARGES_SECTION", data: selectedEquipments });
    // yield* UpdateFloatingCart();
}

function* updateDirectoryListing(listingInfo) {

    const constructedListingInfo = [
        {
            "Name": listingInfo.data,
            "Rc": "0.00"
        }
    ];
    yield put({ type: "UPDATE_DIRECTORY_LISTING_IN_STATE", data: constructedListingInfo });
    // yield* UpdateFloatingCart();
}

function* updateFaxLineForBDV(faxLineInfo) {
    //value: "No Standard Phone Line"value: "Add Standard Phone Line"

    if (faxLineInfo.data.value === "Add Standard Phone Line") {
        const phoneNumber = faxLineInfo.data?.SelectedFaxlines[0]?.OldTN;
        const formattedPhoneNumber = phoneNumber?.replace(/-/g, "");
        const price = faxLineInfo.data?.selectedPrice?.toString();

        const constructedFaxLineInfo = [
            {
                "prdName": "Measured Rate Local Calling Service - 24 Month Term",
                "keyWord": formattedPhoneNumber,
                "Price": price,
                "WMName": "No Maintenance Plan",
                "WMPrice": "0",
                "isRouterDisc": false
            }
        ];

        yield put({ type: "UPDATE_BDV_FAXLINE_IN_STATE", data: constructedFaxLineInfo });
    }
    else if (faxLineInfo.data.value === "No Standard Phone Line") {
        yield put({ type: "UPDATE_BDV_FAXLINE_IN_STATE", data: "" });
    }

    // yield* UpdateFloatingCart();
}

function* updateTvPlan(tvPlan) {
    const constructedTvPlanInfo = {
        "Title": tvPlan.data.PrdName,
        "TVTitle": tvPlan.data.PrdName,
        "type": "TV",
        "price": tvPlan.data.price,
    };
    yield put({ type: "UPDATE_TV_PLAN_IN_STATE", data: constructedTvPlanInfo });
    yield* UpdateTvFloatingCart();
}

function* updatePremChannels(premChannels) {
    const channels = Object.values(premChannels.data).filter(x => x.value).map(prd =>
        ({
            "prdName": prd.PrdName,
            "keyWord": prd.Keyword,
            "Price": prd.PrdPrice,
            "WMName": null,
            "WMPrice": null,
            "isRouterDisc": false,
        }));

    yield put({ type: "UPDATE_PREM_CHANNELS_IN_STATE", data: channels });
    yield* UpdateTvFloatingCart();
}

function* updateTvEquipment(tvEquip) {

    const equips = Object.values(tvEquip.data).map(prd =>
        ({
            "prdName": prd.PrdName,
            "keyWord": prd.Keyword,
            "Price": prd.PrdPrice,
            "WMName": null,
            "WMPrice": null,
            "isRouterDisc": false,
        }));

    yield put({ type: "UPDATE_TV_EQUIPMENT_IN_STATE", data: equips })
    yield* UpdateTvFloatingCart();
}

function* updateTvRecording(tvRec) {

    let dvr = null;
    if (tvRec?.data) {
        dvr = {
            "prdName": tvRec.data.PrdName,
            "keyWord": tvRec.data.Keyword,
            "Price": tvRec.data.PrdPrice,
            "WMName": null,
            "WMPrice": null,
            "isRouterDisc": false,
        };
    }

    yield put({ type: "UPDATE_TV_RECORDING_IN_STATE", data: dvr });
    yield* UpdateTvFloatingCart();
}

function* updateInternetPlan(plan) {
    plan.data.title = plan.data.SC.split(';')[1];
    const internetSection = {
        "price": plan.data.BundleRC
    };

    yield put({ type: "UPDATE_INTERNET_PLAN_IN_STATE", data: plan.data });
    yield* UpdateTvFloatingCart();
}

function* updateInternetIP(plan) {

    yield put({ type: "UPDATE_INTERNET_IP_IN_STATE", data: plan.data });
    yield* UpdateTvFloatingCart();
}

function* UpdateFloatingCart() {
    try {
        const listingInfo = yield select(selectors.listingInfo);
        const faxLineInfo = yield select(selectors.faxLineInfo);
        const lines = yield select(selectors.lines);
        const price = yield select(selectors.price);
        const equipments = yield select(selectors.equipments);

        const numberOfLines = lines ? lines?.length : 1;

        const totalPrice = (parseInt(price) * numberOfLines).toString();


        let constructedgetFloatCartResponse = {
            "CRMMOffers": [],
            "DataInfo": {
                "DataPlans": null,
                "DataSpeed": null,
                "Title": null
            },
            "HeaderInfo": {
                "AmexOffer": null,
                "DataTitle": null,
                "FneDisc": "0",
                "Ftype": "BDV",
                "is2moth": false,
                "isHDSTB": false,
                "isNYDMA": "Y",
                "isSymmetrical": false,
                "OneFCouponQual": null,
                "ONTTYPE": null,
                "PGDiscount": null,
                "PGTerm": "",
                "PhoneTitle": "Four Business Digital Voice Lines",
                "Price": "140.00", /* ignore*/
                "Term": "TwoYears",
                "Title": "Four Business Digital Voice(s)",
                "tmnthAddlprice": null,
                "tmnthTpBundleTVPrice": null,
                "TvTitle": null
            },
            "PhoneInfo": {
                "accountLevel": [
                    {
                        "isRouterDisc": false,
                        "keyWord": null,
                        "prdName": "Non published Listing",
                        "Price": "0.00",
                        "WMName": null,
                        "WMPrice": null
                    }
                ],
                /*"FaxLine": [{
                    "prdName":"Measured Rate Local Calling Service - 24 Month Term",
                    "keyWord":"8455625716",
                    "Price":"19.35",
                    "WMName":"No Maintenance Plan",
                    "WMPrice":"0",
                    "isRouterDisc":false
                }],*/
                /*"lineLevel": [
                    {
                        "plans": [],
                        "PName": "Business Digital Voice",
                        "TN": "2122203081"
                    },
                    {
                        "plans": [],
                        "PName": "Business Digital Voice",
                        "TN": "2122203082"
                    },
                    {
                        "plans": [],
                        "PName": "Business Digital Voice",
                        "TN": "2122203083"
                    },
                    {
                        "plans": [],
                        "PName": "Business Digital Voice",
                        "TN": "2122203084"
                    }
                ]*/
            },
            "TVInfo": {
                "PlanName": null,
                "TVPlans": null
            }
        };

        if (faxLineInfo) {
            constructedgetFloatCartResponse.PhoneInfo.FaxLine = faxLineInfo;
        }

        if (lines) {
            constructedgetFloatCartResponse.PhoneInfo.lineLevel = lines;
        }

        let constructedgetCartInfoResponse = [
            [],
            [],
            [
                {
                    "offerName": "3 Line IP Phone(1)",
                    "price": 85,
                    "type": "BDV",
                    "wavied": false
                },
                {
                    "offerName": "4 Port Analog Converter(1)",
                    "price": 130,
                    "type": "BDV",
                    "wavied": false
                },
                {
                    "offerName": "Business Digital Voice Shipping(2)",
                    "price": "0.00",
                    "type": "NONBDV",
                    "wavied": false
                }
            ],
            {
                "AmexOffer": "N",
                "bdvTerm": 12,
                "contract": "TwoYears",
                "Covid19txt": "",
                "CurrentStage": "",
                "dataTerm": 3,
                "FBEGK": "N",
                "FlowType": "NC",
                "hasBDVGigabitOffer": "N",
                "hasTechPro": "N",
                "hasTechProOffer": "N",
                "ISBDV": true,
                "OfferLst": [],
                "pgTerm": "",
                "phoneTitle": "Four Business Digital Voice(s) ",
                "price": totalPrice,
                "PriceQuoteId": "NY40004364064",
                "QuoteExpiry": "",
                "SaveOrderHead": "N",
                "state": "NY",
                "Title": "Four Business Digital Voice(s) ",
                "tmonthtotalPrice": 0,
                "type": "BDV"
            }
            /*,
            {
                "Fmonth": [
                    {
                        "IsBdvEquip": false,
                        "offerName": "",
                        "price": 0,
                        "wavied": false
                    },
                    {
                        "IsBdvEquip": false,
                        "offerName": "",
                        "price": 0,
                        "wavied": false
                    },
                    {
                        "IsBdvEquip": false,
                        "offerName": "",
                        "price": 0,
                        "wavied": false
                    }
                ],
                "four211": [
                    {
                        "IsBdvEquip": false,
                        "offerName": "",
                        "price": 0,
                        "wavied": false
                    },
                    {
                        "IsBdvEquip": false,
                        "offerName": "",
                        "price": 0,
                        "wavied": false
                    }
                ],
                "Smonth": [
                    {
                        "IsBdvEquip": false,
                        "offerName": "",
                        "price": 0,
                        "wavied": false
                    },
                    {
                        "IsBdvEquip": false,
                        "offerName": "",
                        "price": 0,
                        "wavied": false
                    }
                ],
                "thr224": [],
                "Tmonth": [
                    {
                        "IsBdvEquip": false,
                        "offerName": "",
                        "price": 0,
                        "wavied": false
                    },
                    {
                        "IsBdvEquip": false,
                        "offerName": "",
                        "price": 0,
                        "wavied": false
                    }
                ],
                "twleve": [
                    {
                        "IsBdvEquip": false,
                        "offerName": "",
                        "price": 0,
                        "wavied": false
                    },
                    {
                        "IsBdvEquip": false,
                        "offerName": "",
                        "price": 0,
                        "wavied": false
                    }
                ]
            }*/
        ];

        if (listingInfo) {
            constructedgetCartInfoResponse.push(listingInfo);
        }

        if (equipments) {
            const temp = {
                "Fmonth": equipments
            };
            constructedgetCartInfoResponse.push(temp);
        }

        yield put({ type: "UPDATE_GET_CART_INFO_RESPONSE", data: constructedgetCartInfoResponse });
        yield put({ type: "UPDATE_GET_FLOAT_CART_RESPONSE", data: constructedgetFloatCartResponse });
    } catch (ex) {
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: ex } });
    }

}

function* UpdateTvFloatingCart() {
    // const listingInfo = yield select(selectors.listingInfo);
    // const faxLineInfo = yield select(selectors.faxLineInfo);
    // const lines = yield select(selectors.lines);
    // const price = yield select(selectors.price);
    // const equipments = yield select(selectors.equipments);
    const tvPlan = yield select(selectors.tvPlan);
    const premChannels = yield select(selectors.premChannels);
    const tvEquip = yield select(selectors.tvEquip);
    const tvRec = yield select(selectors.tvRec);
    const internetPlan = yield select(selectors.internetPlan);

    let floatRes = {
        "CRMMOffers": [],
        "HeaderInfo": {
            "AmexOffer": null,
            "DataTitle": null,
            "FneDisc": "0",
            "Ftype": null,
            "is2moth": false,
            "isHDSTB": false,
            "isNYDMA": "Y",
            "isSymmetrical": false,
            "OneFCouponQual": null,
            "ONTTYPE": null,
            "PGDiscount": null,
            "PGTerm": "",
            "PhoneTitle": null,
            "Price": "0", /* ignore*/
            "Term": "TwoYears",
            "Title": "",
            "tmnthAddlprice": null,
            "tmnthTpBundleTVPrice": null,
            "TvTitle": null
        },
        "DataInfo": {
            DataPlans: []
        },
        "PhoneInfo": {},
        "TVInfo": {
            TVPlans: []
        }
    };

    // if (faxLineInfo) {
    //     constructedgetFloatCartResponse.PhoneInfo.FaxLine = faxLineInfo;
    // }

    // if (lines) {
    //     constructedgetFloatCartResponse.PhoneInfo.lineLevel = lines;
    // }

    if (internetPlan) {
        const title = internetPlan.SC.split(';')[1];
        floatRes.HeaderInfo.Title = title;
        floatRes.HeaderInfo.DataTitle = title;
        floatRes.HeaderInfo.Price = internetPlan.BundleRC;
        floatRes.HeaderInfo.Ftype = 'FIOS';
        floatRes.HeaderInfo.Term = internetPlan.Contract;
        floatRes.DataInfo.DataSpeed = Number.parseInt(internetPlan.Services[0].UP_SPEED) * 1000000;
    }

    if (tvPlan) {
        floatRes.HeaderInfo.Title = tvPlan?.Title;
        floatRes.HeaderInfo.TvTitle = tvPlan.TVTitle;
        floatRes.HeaderInfo.Price = tvPlan.price;
        floatRes.HeaderInfo.FType = tvPlan.type;
    }

    if (premChannels) {
        if (!floatRes.TVInfo?.TVPlans) {
            floatRes.TVInfo.TVPlans = premChannels;
        } else {
            floatRes.TVInfo.TVPlans.push(...premChannels);
        }
    }

    if (tvEquip) {
        if (!floatRes.TVInfo?.TVPlans) {
            floatRes.TVInfo.TVPlans = tvEquip;
        } else {
            floatRes.TVInfo.TVPlans.push(...tvEquip);
        }
    }

    if (tvRec) {
        if (!floatRes.TVInfo?.TVPlans) {
            floatRes.TVInfo.TVPlans = [tvRec];
        } else {
            floatRes.TVInfo.TVPlans.push(tvRec);
        }
    }

    let cartRes = [
        {
            "FBEGK": "N",
            "hasTechPro": "N",
            "hasTechProOffer": "N",
            "hasBDVGigabitOffer": "N",
            "state": "NY",
            "AmexOffer": "N",
            "PriceQuoteId": "",
            "QuoteExpiry": "",
            "CurrentStage": "",
            "Covid19txt": "",
            "SaveOrderHead": "N",
            "OfferLst": [],
            "FlowType": "NC",
            "tmonthtotalPrice": 0.0,
            "pgTerm": "",
            "tax": "0",
            "fbilltax": "0",
            "PartialTotal": "0",
            "TVTitle": "",
            "price": "0",
            "type": "TV",
            "Title": "",
            "contract": "NoContract",
            "bdvTerm": "",
            "dataTerm": 3
        }, [], [], [], [], [], [], [], [],
        {
            "Fmonth": [],
            "Smonth": [],
            "Tmonth": [],
            "four211": [],
            "twleve": [],
            "thr224": []
        }
    ];

    // if (listingInfo) {
    //     constructedgetCartInfoResponse.push(listingInfo);
    // }

    // if (equipments) {
    //     const temp = {
    //         "Fmonth": equipments
    //     };
    //     constructedgetCartInfoResponse.push(temp);
    // }

    if (internetPlan) {
        cartRes[0].Title = internetPlan?.title;
        cartRes[0].price = internetPlan.BundleRC;
        cartRes[0].type = 'FIOS';
        cartRes[0].contract = internetPlan.Contract;
        cartRes[1] = { "plan": internetPlan?.title };
    }

    if (tvPlan) {
        cartRes[0].Title = tvPlan?.Title;
        cartRes[0].TVTitle = tvPlan.TVTitle;
        cartRes[0].type = tvPlan.type;
        cartRes[0].price = tvPlan.price;
    }


    yield put({ type: "UPDATE_GET_CART_INFO_RESPONSE", data: cartRes });
    yield put({ type: "UPDATE_GET_FLOAT_CART_RESPONSE", data: floatRes });
}

function* updateCart(params) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    const { data } = params;
    const ProductType = data.type;
    const subProductType = data.subType;
    //let content = data.data;
    let content = Object.assign({}, data.data);

    let requestBody = { ProductType };

    const flowType = data.flowType;

    const internet = yield select(selectors.internet);
    const internetRouterList = yield select(selectors.internetRouterList);
    const servicesInCart = yield select(selectors.servicesInCart);
    const tv = yield select(selectors.tv);
    const standaloneTvFlowDataRes = yield select(selectors.standaloneTvFlowDataRes);
    let phone = yield select(selectors.phone);
    let voice = yield select(selectors.voice);
    let isWinbackSelected = yield select(selectors.isWinbackSelected);
    const BDVInfoResponse = yield select(selectors.BDVInfoResponse);
    const getPostLqData = yield select(selectors.getPostLqData);

    let equipmentMappingNumber = BDVInfoResponse?.TNList?.TNObject[0]?.TN?.replace(/-/g, "");
    if (isWinbackSelected && isWinbackSelected[0].NewIsWB === 'Y') {
        equipmentMappingNumber = isWinbackSelected && isWinbackSelected[0] ? isWinbackSelected[0].NewTN : equipmentMappingNumber;
    }

    const BdvListings = BDVInfoResponse?.Listings;
    if (ProductType === PRD_TYPES.FIOS) {
        if (subProductType === "EQUIPMENT") {
            const { RouterSelection } = internet;
            if (!RouterSelection?.NewID) {
                const selectedRouterFromAPI = internetRouterList ? internetRouterList?.filter(router => router.IsSelected === true) : '';
                const initialOldID = selectedRouterFromAPI[0] ? selectedRouterFromAPI[0].PrdID : '';
                content.RouterSelection.OldID = initialOldID;
            } else {
                content.RouterSelection.OldID = RouterSelection?.NewID;
            }
            if (content.RouterSelection.NewID === content.RouterSelection.OldID) {
                content.RouterSelection.OldID = '';
            }
        }
        yield put({ type: "UPDATE_INTERNET_CART_SELECTION", data: { ...internet, ...content } });
        requestBody = { ...requestBody, fiOSDataModelPost: content };
    } else if (ProductType === PRD_TYPES.HSI) {
        if (subProductType === "EQUIPMENT") {

            if (!internet.RouterSelection?.NewID) {
                content.RouterSelection.OldID = '';
                if (BUNDLE.HSI_PHONE === servicesInCart) {
                    const recomendedFromAPI = filter(internetRouterList, router => router.IsRecomd === true);
                    let initialOldID = recomendedFromAPI && recomendedFromAPI[0] && recomendedFromAPI[0].ProductId ? recomendedFromAPI[0].ProductId : '';
                    content.RouterSelection.OldID = initialOldID;
                }
            } else {
                content.RouterSelection.OldID = internet.RouterSelection?.NewID;
            }

            if (content.RouterSelection.OldID === content.RouterSelection.NewID) {
                content.RouterSelection.OldID = '';
            }
        }
        yield put({
            type: "UPDATE_INTERNET_CART_SELECTION",
            data: { ...internet, ...content }
        });
        requestBody = { ...requestBody, hsiDataModelPost: content };

    } else if (ProductType === PRD_TYPES.TV) {
        if (subProductType === "SUPPORT") {
            content.RouterSelection = content.RouterSelection ? content.RouterSelection : tv.RouterSelection;
            // add plan selection body for all requests if needed.
            content.PlanSelection = content.PlanSelection ? content.PlanSelection : tv.PlanSelection;
        }
        // if (subProductType === "EQUIPMENT") {
        //     content.RouterSelection.OldID = '';
        // }

        if (subProductType === "EQUIPMENT") {
            const { RouterSelection } = tv;
            if (!RouterSelection?.NewID) {
                content.RouterSelection.OldID = '';
            } else {
                content.RouterSelection.OldID = RouterSelection?.NewID;
            }
            if (content.RouterSelection.OldID === content.RouterSelection.NewID) {
                content.RouterSelection.OldID = '';
            }
        }

        // commented for unnecessary addition of channels while changing the equipments

        // if (subProductType === 'TVEQUIPMENT' || subProductType === 'EQUIPMENT' || subProductType === 'SUPPORT') {
        //     content.MovieSelection = content.MovieSelection ? content.MovieSelection : tv.MovieSelection;
        //     content.InternationalSelection = content.InternationalSelection ? content.InternationalSelection : tv.InternationalSelection;
        //     content.SportsSelection = content.SportsSelection ? content.SportsSelection : tv.SportsSelection;
        //     content.SpecialitySelection = content.SpecialitySelection ? content.SpecialitySelection : tv.SpecialitySelection;
        // }

        if (!content.SelectedPPS && tv.SelectedPPS) { content.SelectedPPS = tv.SelectedPPS }

        yield put({ type: "UPDATE_TV_CART_SELECTION", data: { ...tv, ...content } });
        if (servicesInCart === BUNDLE.BDV_DATA_VIDEO || servicesInCart === BUNDLE.FLEX) {
            if (subProductType === "EQUIPMENT") {
                content.SelectedEquipments = undefined;
                content = JSON.parse(JSON.stringify(content));
                requestBody.ProductType = 'FIOSDATA';
                requestBody = {
                    ...requestBody, fiOSDataModelPost: content
                };
            } else {
                content.RouterSelection = undefined;
                content = JSON.parse(JSON.stringify(content));
                requestBody = { ...requestBody, FiOSTVModelPost: content };
            }
        } else {
            requestBody = { ...requestBody, FiOSTVModelPost: content };
        }
    } else if (ProductType === PRD_TYPES.BDV) {
        //requestBody.BdvPhoneLines = phone.BdvPhoneLines;
        if (subProductType === "EQUIPMENT") {
            const selectedProducts = content;
            const desktopList = selectedProducts.desktopList || [];
            const cordsList = selectedProducts.cordsList || [];
            const accessoriesList = selectedProducts.accessoriesList || [];

            const selectedIds = [];

            for (let i = 0; i < desktopList?.length; i++) {
                const item = desktopList[i];
                if (+item.Quantity > 0 && item.updateCart) {
                    let itemCount = 1
                    while (itemCount <= +item.Quantity) {
                        selectedIds.push(item.ProductId);
                        itemCount++
                    }
                }
            }

            for (let i = 0; i < accessoriesList?.length; i++) {
                const item = accessoriesList[i];
                if (+item.Quantity > 0 && item.updateCart) {
                    let itemCount = 1
                    while (itemCount <= +item.Quantity) {
                        selectedIds.push(item.ProductId);
                        itemCount++
                    }
                }
            }

            for (let i = 0; i < cordsList?.length; i++) {
                const item = cordsList[i];
                if (+item.Quantity > 0 && item.updateCart) {
                    let itemCount = 1
                    while (itemCount <= +item.Quantity) {
                        selectedIds.push(item.ProductId);
                        itemCount++
                    }
                }
            }
            let EquipMapping = {
                "EquipMapping": selectedIds.map(id => ({ EqpID: id, AddlHandset: '', TNs: [equipmentMappingNumber] }))
            }
            yield put({ type: "UPDATE_PHONE_CART_SELECTION", data: { ...phone, ...EquipMapping } });
            if (EquipMapping?.EquipMapping?.length === 0) {
                let zeroObj = { "EqpID": "NoEquipment", "AddlHandset": "", "TNs": [] };
                EquipMapping.EquipMapping.push(zeroObj);
            }
            requestBody = { ...requestBody, BdvModelPost: EquipMapping };
        } else if (subProductType === "LISTING") {
            const { City, PhoneNo, CompanyName, FirstName, LastName, Street } = content;

            let BdvDirListing = {};

            const listingObject = BdvListings.filter(info => info.ProductName === "Listing");
            const nonListingObject = BdvListings.filter(info => info.ProductName === "Non published Listing");

            if (content.ProductName === "Non published Listing") {
                BdvDirListing = {
                    "BdvDirListing": { "NewID": content.ProductId, "OldID": listingObject?.length > 0 ? listingObject[0].ProductId : "" }
                }
            } else {
                BdvDirListing = {
                    "BdvDirListing": { "NewID": content.ProductId, "OldID": nonListingObject?.length > 0 ? nonListingObject[0].ProductId : "" },
                    "BdvListingInfo": {
                        "City": City ? City : "",
                        "CompanyName": CompanyName ? CompanyName : "",
                        "FirstName": FirstName ? FirstName : "",
                        "LastName": LastName ? LastName : "",
                        "PhoneNo": PhoneNo ? PhoneNo?.replace(/-/g, "") : "",
                        "Street": Street ? Street : "",
                    }
                }
            }
            if (BdvDirListing.BdvDirListing.OldID === BdvDirListing.BdvDirListing.NewID) {
                BdvDirListing.BdvDirListing.OldID = '';
            }
            yield put({ type: "UPDATE_PHONE_CART_SELECTION", data: { ...phone, ...BdvDirListing } });
            requestBody = { ...requestBody, BdvModelPost: BdvDirListing };
        }
        else {
            yield put({ type: "UPDATE_PHONE_CART_SELECTION", data: { ...phone, ...content } });
            requestBody = { ...requestBody, BdvModelPost: content };
        }
    } else if (ProductType === PRD_TYPES.VOICE) {
        if (subProductType === "LISTING") {

            const { ProductId, ProductName, City, Degree, Designation, PhoneNo, CompanyName, FirstName, LastName, MidName, Street, YellowPageHeading } = content;

            let DirListingObject = {};

            if (["Non Published", "Non Listed"].indexOf(ProductName) > -1) {
                DirListingObject = {
                    "DirListing": {
                        "OldID": voice?.DirListing?.NewID,
                        "NewID": ProductId ? ProductId : ""
                    }
                }
            } else {
                DirListingObject = {
                    "DirListing": {
                        "OldID": voice?.DirListing?.NewID,
                        "NewID": ProductId ? ProductId : ""
                    },
                    "ListingInfo": {
                        "City": City ? City : "",
                        "CompanyName": CompanyName ? CompanyName : "",
                        "Degree": Degree ? Degree : "",
                        "Designation": Designation ? Designation : "",
                        "FirstName": FirstName ? FirstName : "",
                        "LastName": LastName ? LastName : "",
                        "MidName": MidName ? MidName : "",
                        "PhoneNo": PhoneNo ? PhoneNo?.replace(/-/g, "") : "",
                        "Street": Street ? Street : "",
                        "YellowPageHeading": YellowPageHeading ? YellowPageHeading : ""
                    }
                }
            }
            if (DirListingObject.DirListing.OldID === DirListingObject.DirListing.NewID) {
                DirListingObject.DirListing.OldID = '';
            }
            if (voice?.DirListing?.NewID !== ProductId) {
                yield put({ type: "UPDATE_VOICE_CART_SELECTION", data: { ...voice, ...DirListingObject } });
            }
            requestBody = { ...requestBody, VoiceModelPost: DirListingObject };

        } else {
            yield put({ type: "UPDATE_VOICE_CART_SELECTION", data: { ...voice, ...content } });
            requestBody = { ...requestBody, VoiceModelPost: content };
        }
    }

    try {
        const response = yield apiClient.post(UPDATE_CART_URL, requestBody);
        // yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Info', message: JSON.stringify(requestBody) } });
        if (response && response.data) {
            console.log(response);
            if (response.data && params?.data?.loadType && (servicesInCart === BUNDLE.BDV_DATA_VIDEO || servicesInCart === BUNDLE.FLEX) &&
                ProductType === PRD_TYPES.TV) {
                yield fork(updateCartTVSTB, params);
            }
            if (getPostLqData?.UpdateWithGetCartDetails === "Y") {
                yield* processFloatingCartDetails(response.data);
            }

        }
    } catch (e) {
        console.log(e);
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    } finally {
        //yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        // yield call(getFloatingCartDetails);
        if (getPostLqData?.UpdateWithGetCartDetails !== "Y") {
            yield call(getFloatingCartDetails);
        }

    }

}

function* updateCartTVSTB(params) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    const { data } = params;
    const ProductType = data.type;
    let content = Object.assign({}, data.data);
    const getPostLqData = yield select(selectors.getPostLqData);

    let requestBody = { ProductType };

    const servicesInCart = yield select(selectors.servicesInCart);
    const tv = yield select(selectors.tv);
    yield put({ type: "UPDATE_TV_CART_SELECTION", data: { ...tv, ...content } });
    if (servicesInCart === BUNDLE.BDV_DATA_VIDEO || servicesInCart === BUNDLE.FLEX) {
        content.RouterSelection = undefined;
        content = JSON.parse(JSON.stringify(content));
        requestBody = { ...requestBody, FiOSTVModelPost: content };
    }
    try {
        const response = yield apiClient.post(UPDATE_CART_URL, requestBody);
        // yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Info', message: JSON.stringify(requestBody) } });
        if (response && response.data) {
            if (getPostLqData?.UpdateWithGetCartDetails === "Y") {
                yield* processFloatingCartDetails(response.data);
            }
        }
    } catch (e) {
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    }

}

export function* floatingCartActionWatcher() {
    yield takeLatest('UPDATE_SELECTED_PHONE_SERVICE_IN_CART', updateSelectedPhoneService);
    yield takeLatest('UPDATE_N_LINES_IN_CART', updateNLines);
    yield takeLatest('UPDATE_BDV_FAXLINE_IN_CART', updateFaxLineForBDV);
    yield takeLatest('UPDATE_DIRECTORY_LISTING_IN_CART', updateDirectoryListing);
    yield takeLatest('UPDATE_EQUIPMENTS_IN_CART', updateEquipments);
    yield takeLatest('UPDATE_TV_PLAN_IN_CART', updateTvPlan);
    yield takeLatest('UPDATE_PREMIUM_CHANNELS_IN_CART', updatePremChannels);
    yield takeLatest('UPDATE_TV_EQUIPMENT_IN_CART', updateTvEquipment);
    yield takeLatest('UPDATE_TV_RECORDING_IN_CART', updateTvRecording);
    yield takeLatest('UPDATE_INTERNET_PLAN_IN_CART', updateInternetPlan);
    yield takeLatest('UPDATE_INTERNET_IP_IN_CART', updateInternetIP);
    yield takeLatest("UPDATE_CART", updateCart);
    yield takeLatest("UPDATE_CART_TVSTB", updateCartTVSTB);

}